<template>
  <div class="mt-10 bg-footer pt-10 h-96 w-full">
    <div
      class="max-w-content h-full mx-auto pl-6 flex flex-column justify-center text-white text-base"
    >
      <h2 class="text-white mb-2.5 text-2xl font-black">
        {{ title }}
      </h2>
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ title: string; content: string }>();
</script>

<style scoped>
a {
  color: white;
}
</style>
